import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
import Moment from 'moment-timezone';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import moment from 'moment-timezone';
import CommonDialog from '../../components/modal-dialog/common-dialog/common-dialog';
import LoginService from "../../services/login.service";

function ScheduleGridFormatter(params, observableOptions) {

    var self = this;

    self.observableOptions = observableOptions;

    self.formatterCommon = FormatterCommon;
    self.gridFormatterCommon = new GridFormatterCommon();

    self.type = params.appId;

    self.observableFormattedData = ko.observable({});

    self.subscriptions = [];
}

function capitalizeFirstLetter(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : null;
}

function editSchedule(scheduleObj) {
    if (scheduleObj.frequency === 'Once') {
        return;
    }
    var scheduleModalVm = ko.dataFor($("#ScheduleModal")[0]);
    scheduleModalVm.setScheduleForEdit(scheduleObj);

    $("#ScheduleModal").modal('show');
}

function removeSchedule(scheduleObj) {
    CommonDialog.confirm('Are you sure you want to delete this schedule?').then(function(confirmed) {
        if (confirmed) {
            var scheduleModalVm = ko.dataFor($("#ScheduleModal")[0]);
            scheduleModalVm.removeSchedule(scheduleObj, function(){
                $("#ScheduleModal").trigger('hidden.bs.modal');
            });
        }
    });
}

function runScheduleNow(scheduleObj) {
    if (scheduleObj.frequency === 'Once') {
        return;
    }
    let message;
    if (scheduleObj.notifications && scheduleObj.notifications.length === 1 && scheduleObj.notifications[0].channel === 'eai') {
      message = 'The file will be created in a few minutes.';
    } else {
      message = 'Report will be emailed in a few minutes.';
    }
    var scheduleModalVm = ko.dataFor($("#ScheduleModal")[0]);
    scheduleModalVm.runScheduleNow(scheduleObj);

    alert(message);
}

function enableDisableSchedule(scheduleObj) {
    if (scheduleObj.frequency === 'Once') {
        return;
    }
    var scheduleModalVm = ko.dataFor($("#ScheduleModal")[0]);
    scheduleModalVm.enableDisableSchedule(scheduleObj);
}

function ComposeData(formatterCommon, gridFormatterCommon, sourcelist, apptype, options, initFlag, currentUserId, self) {
    if (!sourcelist || $.isEmptyObject(sourcelist)) {
        return {
            maxCount: 0,
            rows: [],
        };
    }
    var list = [];
    var finalList = [];
    var searchfilter = _.get(options, 'filter.search', null);
    var modifierCriterion = _.get(options, 'filter.modifier', null);

    sourcelist.forEach(function (item) {

        // appTypes: "webex", "historical","historical2", "lync";
        if (item.category && item.category !== apptype) {
            return;
        }
        if ((item.frequency === "Once") || (item.frequency === "Now")) {
            return;
        }

        // Backwards compatibility (old reports use createdDate)
        var createdDate = item.createdDate || item.createdDateTime;

        item._createdDate = createdDate ? moment(createdDate).format('MM/DD/YYYY hh:mm:ss') : '';
        item.id = item.id || item._id;

        var searchmatch = _.isEmpty(searchfilter) ||
            gridFormatterCommon.MatchItemToSearch(item, searchfilter, ["name", "reportingPeriod", "frequency", "createdByName", "_createdDate"],
            gridFormatterCommon.transformValueForSearchCommon);

        var modifierMatch = !modifierCriterion || (modifierCriterion === 'all') || (item.createdByUserId === currentUserId);

        if (modifierMatch && searchmatch) {
            list.push({ name: item.name, reportingPeriod: item.reportingPeriod, frequency: item.frequency, createdBy: item.createdByName, createdDate: item._createdDate, status: item.enabled, _origObj: item });
        }
    });
    var sortableProperties = ['name', 'reportingPeriod', 'frequency', 'createdBy', 'createdDate', 'status'];
    var dateProperties = ['createdDate'];
    var sortedList = gridFormatterCommon.sortList(list, sortableProperties, options, undefined, dateProperties);
    var pagedList = gridFormatterCommon.pageList(sortedList, options);

    pagedList.forEach(function (item) {
        var sanitizedName = formatterCommon.sanitize(capitalizeFirstLetter(item.name));

        finalList.push({
            id: item._origObj.id,
            name: '<a title="' + sanitizedName + '" style="font-weight: bold;color: var(--hover-color);cursor: pointer;" href="' + self.getUrlHash(item._origObj.lastPermaLink || item._origObj.url) + '">' + sanitizedName + '</a>',
            reportingPeriod: formatterCommon.sanitize(item.reportingPeriod),
            frequency: formatterCommon.sanitize(item.frequency),
            createdBy: formatterCommon.sanitize(item.createdBy),
            createdDate: formatterCommon.sanitize(item.createdDate),
            runNow: item.frequency === 'Once' ? "" : '<i style="font-size:15px;cursor:pointer" class="fa fa-play" title="Run Now"></i>',
            edit: item.frequency === 'Once' ? "" : '<i style="font-size:15px;cursor:pointer" class="fa fa-edit" title="Edit"></i>',
            remove: '<i style="font-size:15px;cursor:pointer" class="fa fa-trash" title = "Delete"></i>',
            status: item.status,
            _origObj: item._origObj,
            _actionCallback: function(index, cell) {
                if (index === 6) {
                    runScheduleNow(this._origObj);
                }
                else if (index === 7) {
                    editSchedule(this._origObj);
                }
                else if (index === 8) {
                    removeSchedule(this._origObj);
                }
                else if (index === 5) {
                    enableDisableSchedule(this._origObj);
                    self.RefreshData();
                }
            }
        });
    });
    let columnProperties = ['name', 'reportingPeriod', 'frequency', 'createdBy', 'createdDate', 'status', 'runNow', 'edit', 'remove'];
    let headers = ['Name', 'Period', 'Frequency', 'Created By', 'Created On', 'Status', 'Run Now', 'Edit', 'Delete'];
    let tabulatorColumns = headers.map(function (header, index) {
        let column = {
            field: columnProperties[index],
            minWidth: 100,
            title: header,
        };
        if (header === 'Created On') {
            column.formatter = function(cell) {
                let time = new Moment(new Date(cell.getValue()));
                return time.format('MMMM Do YYYY, h:mm:ss a');
            }
            column.minWidth = 150;
        }
        if ([0,5,6,7,8].indexOf(index) > -1) {
            column.formatter = 'html';
        }
        if ([5,6,7,8].indexOf(index) > -1) {
            column.cellClick = function(e, cell) {
                cell.getData()._actionCallback(index, cell);
            };
            column.minWidth = 50;
            if (index !== 5) {
                column.headerSort = false;
            }
        }
        if (header === 'Status') {
            column.formatter = function(cell) {
              let item = cell.getData();
              if (cell.getValue()) {
                  cell.getElement().classList.add('enabled');
              } else {
                  cell.getElement().classList.remove('enabled');
              }
              return '<div title="' + (cell.getValue() ? 'Enabled' : 'Disabled') + '" class="btn-group" data-toggle="buttons">'
                    + '<div class="btn btn-default btn-xs">'
                      + '<input type="checkbox" id="toggle_' + item._origObj.id + '" value="' + (cell.getValue() ? '1' : '0') + '"' + (cell.getValue() ? ' checked' : '') + '>'
                      + '<span>' + (cell.getValue() ? 'Enabled' : 'Disabled') + '</span>'
                    + '</div></div>'
            }
        }
        return column;
    });

    return {
        maxCount: list.length,
        rows: finalList,
        widths: ['18%', '18%', '12%', '12%', '12%', '6%', '6%', '6%', '6%'],
        tabulatorColumns: tabulatorColumns
    };
}

ScheduleGridFormatter.prototype.RefreshData = function () {
    var self = this;
    self.observableFormattedData(ComposeData(self.formatterCommon, self.gridFormatterCommon, self.sourceList(), self.type, self.observableOptions(), null, self.userId, self));
};

ScheduleGridFormatter.prototype.DataUpdated = function () {
    var self = this;
    self.RefreshData();
};

ScheduleGridFormatter.prototype.OptionsUpdated = function () {
    var self = this;
    self.RefreshData();
};

ScheduleGridFormatter.prototype.initialize = function (dataRepository, dataProvider) {
    var self = this;

    self.dataRepository = dataRepository;
    self.userId = LoginService.userObject.userId;
    self.sourceList = dataRepository.exportRegistrations;

    if (self.sourceList) {
        self.subscriptions.push(self.sourceList.subscribe(function () { self.DataUpdated(); }));
    }
    self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

    //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
    if (self.sourceList()) {
        self.RefreshData();
    }
};

ScheduleGridFormatter.prototype.getObservableData = function () {
    var self = this;
    return self.observableFormattedData;
};

ScheduleGridFormatter.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

ScheduleGridFormatter.prototype.getUrlHash = function(url) {
  let hashIndex = url.indexOf('#');
  if (hashIndex > -1) {
    return url.substring(hashIndex);
  }
  return '';
}

export default ScheduleGridFormatter;
